// extracted by mini-css-extract-plugin
export default {"memoryCardsContainer":"MemoryCards_memoryCardsContainer__BZzup"};